/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plan_Duration_WeeksInputs */

const en_plan_duration_weeks = /** @type {(inputs: Plan_Duration_WeeksInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} week`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} weeks`);
	return /** @type {LocalizedString} */ ("plan_duration_weeks");
};

const es_plan_duration_weeks = /** @type {(inputs: Plan_Duration_WeeksInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} semana`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} semanas`);
	return /** @type {LocalizedString} */ ("plan_duration_weeks");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} week" |
* | "other" | "{count} weeks" |
*
* @param {Plan_Duration_WeeksInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_duration_weeks = /** @type {((inputs: Plan_Duration_WeeksInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Duration_WeeksInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_duration_weeks(inputs)
	return en_plan_duration_weeks(inputs)
});